// MfaAuthSelectPanel.js
import React, { useState, useEffect } from 'react';
import styles from '../../MfaPage.module.css';  
import axios from "../../../../utils/api/axios";
import { IAM_MFA_OTP } from '../../../../utils/Config';
import { InnocodeButton, useDialog } from '@intsoft/innocode-core';


function MfaEmailVerifyPanel({ onSuccess, onBack, userId  }) {
    const [emailToken, setEmailToken] = useState('');
    const [isResending, setIsResending] = useState(false);
    const [resendCooldown, setResendCooldown] = useState(60);
    const { showDialog } = useDialog();
    // 컴포넌트가 처음 마운트될 때 이메일 자동 발송
    useEffect(() => {
        emailSend();
    }, []);

    const emailSend = async () => {
        if (isResending) return;
        
        if (!userId) {
            showDialog({
                iconType: "info",
                type: 'info',
                title: "알림",
                message: "사용자 ID가 없습니다.\n로그인 페이지로 돌아갑니다.",
                confirmText: "확인",
            });
            window.location.href = '/login'; 
        }

        setIsResending(true);
        setResendCooldown(60);
        const timer = setInterval(() => {
            setResendCooldown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    setIsResending(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        try {
            const url = `${IAM_MFA_OTP}/email/send-link?unifiedProfileId=`+userId;
            // 서버의 @RequestBody에 맞게 JSON 객체를 직접 전달
            const payload = { unifiedProfileId: userId };
            
            const res = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (res.data.data) {
                setEmailToken(res.data.data);
                showDialog({
                    iconType: "info",
                    type: 'info',
                    title: "인증 메일이\n발송되었습니다.", 
                    confirmText: "확인",
                });

                // showDialog(DialogEnum.DEFAULT, "알림", "인증 메일이 발송되었습니다.");
            } else {
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "오류",
                    message: "이메일 발송에\n실패했습니다.", 
                    confirmText: "확인",
                });
                //  showDialog(DialogEnum.DEFAULT, "오류", "이메일 발송에 실패했습니다.");
                 clearInterval(timer);
                 setIsResending(false);
            }
        } catch (err) {
            console.error('이메일 발송 실패', err);
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "오류",
                message: "이메일 발송에\n실패했습니다.", 
                confirmText: "확인",
            });
            // showDialog(DialogEnum.DEFAULT, "오류", "이메일 발송에 실패했습니다.");
        }
    };
    
    const handleConfirm = async () => {
        if (!emailToken) {
            showDialog({
                iconType: "warning",
                type: 'error', 
                title: "먼저 인증 메일을\n발송해주세요.", 
                confirmText: "확인",
            }); 
             return;
        }

        try {
            const url = `${IAM_MFA_OTP}/email/status`;
            const payload = { token: emailToken };
            const res = await axios.post(url, payload);

            if (res.data.data === 'AUTHENTICATED') {
                onSuccess();
            } else {
                showDialog({
                    iconType: "info",
                    type: 'info',
                    title: "알림",
                    message: "이메일 인증이 완료되지 않았습니다.\n메일함을 확인해 주세요.", 
                    confirmText: "확인",
                }); 
                //  showDialog(DialogEnum.DEFAULT, "알림", "이메일 인증이 완료되지 않았습니다. 메일함을 확인해 주세요.");
            }
        } catch (err) {
            // console.error('이메일 인증 확인 실패', err);
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "오류",
                message: "인증 확인 중 오류가 발생했습니다.", 
                confirmText: "확인",
            });
            // showDialog(DialogEnum.DEFAULT, "오류", "인증 확인 중 오류가 발생했습니다.");
        }
    };

    return (
        <div className={styles.section_wrapper}>
            <div className={styles.section_header_wrapper}>
                <div className={styles.header_text}>이메일 인증</div>
                <div className={styles.header_description}>등록된 이메일로 인증링크를 보냈습니다. <br/>메일함을 확인 후 인증을 완료해 주세요.</div>
            </div>
            <div className={styles.email_verify_code_wrapper}>
                <div className={styles.email_verify_wrapper}>
                    <div className={styles.email_verify_row_wrapper}>
                        <div className={styles.header_description}>이메일이 도착하지 않았나요? 아래 재전송 버튼을 눌러 새 인증메일을 받으세요.</div>
                        {/* <button
                            className={`${components.btn} ${components.btn_solid} ${components.btn_assistive} ${components.btn_md} ${isResending ? styles.disabled : ''}`}
                            onClick={emailSend}
                            disabled={isResending}
                        >
                            <span className={components.btn__text}>
                                {isResending ? `이메일 재전송 (${resendCooldown})` : '이메일 재전송'}
                            </span>
                        </button> */}
                        <InnocodeButton
                         onClick={emailSend}
                         disabled={isResending}
                        >
                            {isResending ? `이메일 재전송 (${resendCooldown})` : '이메일 재전송'}
                        </InnocodeButton>
                    </div>
                </div>
                <div className={styles.submit_btn_container}>
                    <InnocodeButton
                        size='lg'
                        onClick={handleConfirm} 
                        disabled={!emailToken}
                        className={styles.submit_btn}
                    >
                        인증 확인
                    </InnocodeButton>
                    <InnocodeButton
                        size='lg'
                        onClick={onBack}
                        designType='assistive'
                        theme='line'
                        className={styles.submit_btn}
                    >
                        다른 수단으로 인증하기
                    </InnocodeButton> 
                </div>
            </div>
        </div>
    );
}

export default MfaEmailVerifyPanel;
